import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import SettingApi from '../../Api/SettingApi';
import Swal from "sweetalert2";

const Setting = () => {

    // const [rows, setRows] = useState(Array(5).fill({ left: '', right: '' }));

    const [templateData, setTemplateData] = useState([]);
    // const [templateDataApi, setTemplateDataApi] = useState([]);
    const [msgTemplateId, setMsgTemplateId] = useState("");

    const [rows, setRows] = useState(
        Array.from({ length: 5 }, () => ({ left: '', right: '' }))
    );

    const [label] = useState({
        URL: "URL",
        QueryString: "QueryString",
        mobileNoLength: "mobileNoLength",
        encodeSMS: "encodeSMS",
        countryCode: "countryCode",
    });

    const [EmailCrelabel] = useState({
        emailAddress: 'emailAddress',
        Password: 'Password',
        hostName: 'HostName',
        port: 'Port',
        enableSSL: 'enableSSL',
    });


    const [emailField, setEmailField] = useState({
        typeId: 1,
        Email: "email",
        Value: ""
    });


    const [emailCredential, setEmailCredential] = useState({
        typeId: 2,
        emailAddress: '',
        Password: '',
        hostName: '',
        port: '',
        enableSSL: 'true', // default value can be set to "true" or "false"
    });



    const [labelVal, setLabelVal] = useState({
        URL: "",
        QueryString: "",
        mobileNoLength: "",
        encodeSMS: false,
        countryCode: "",
    });

    console.log("labelVal", labelVal);



    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setLabelVal((prevValues) => ({
    //         ...prevValues,
    //         [name]: value,
    //     }));
    // };

    const addRow = () => {
        setRows([...rows, { left: '', right: '' }]);
    };

    // const handleInputChange = (index, side, event) => {
    //     const newRows = [...rows];
    //     newRows[index][side] = event.target.value;

    //     const { name, value } = event.target;
    //     setLabelVal((prevValues) => ({
    //         ...prevValues,
    //         [name]: value,
    //     }));

    //     setRows(newRows);
    // };

    const handleInputChange = (index, field, e) => {

        const { value, name } = e.target;

        const updatedRows = [...rows];

        // Update only the specific row's field (left/right)
        updatedRows[index][field] = value;

        // Update the rows state with the updated array
        setRows(updatedRows);

        setLabelVal((prevState) => ({
            ...prevState,
            [name]: value, // Update the corresponding label value
        }));
    };


    const handleSave = async () => {
        const response = await SettingApi.CreateEmailSetting(emailField)
        if (response) {
            Swal.fire({ title: "Created", text: "Created successfully", icon: "success", width: "320px" })
            console.log("response", response);
        }
    }

    const handleMessageSave = async () => {
        const payload = {
            ...labelVal,
            typeId: 3
        }
        const response = await SettingApi.CreateEmailSetting(payload, label)
        if (response) {
            Swal.fire({ title: "Created", text: "Created successfully", icon: "success", width: "320px" })
            console.log("response", response);
        }
    }

    const handleMessageUpdate = async () => {
        // const payload = {
        //     ...labelVal,

        // }

        const data = [
            { key: label.URL, value: labelVal.URL },
            { key: label.QueryString, value: labelVal.QueryString },
            { key: label.mobileNoLength, value: labelVal.mobileNoLength },
            { key: label.encodeSMS, value: labelVal.encodeSMS },
            { key: label.countryCode, value: labelVal.countryCode }
        ];

        const response = await SettingApi.UpdateByType(3, data)
        if (response) {
            Swal.fire({ title: "Updated", text: "Updated Successfully", icon: "success", width: "320px" })
            console.log("response", response);
        }
    }


    const fetchMessageTemplateData = async (type) => {
        const response = await SettingApi.GetSettingByType(type)
        if (response) {
            console.log("response", response);
            if (type === 3) {
                
                // setTemplateData(response.Result)
                if (response.Result[0]) {
                    setMsgTemplateId(response.Result[0].id)
                }
                const result = response.Result[0]; // Access the first element of the array

                if (result) {
                    setLabelVal({
                        URL: result.F2 || "",
                        QueryString: result.F4 || "",
                        mobileNoLength: result.F6 || "",
                        encodeSMS: result.F8 === "true",
                        countryCode: result.F10 || "",
                    });

                    setRows((prevRows) => {
                        const updatedRows = [...prevRows];
                        updatedRows[0] = { left: "", right: result.F2 || "" };
                        updatedRows[1] = { left: "", right: result.F4 || "" };
                        updatedRows[2] = { left: "", right: result.F6 || "" };
                        updatedRows[3] = { left: "", right: result.F8 === "true" ? "true" : "false" };
                        updatedRows[4] = { left: "", right: result.F10 || "" };
                        return updatedRows;
                    });
                }
            } else if (type === 2) {
                
                let emailCredentials = {};

                response.Result.forEach((item) => {
                    Object.keys(item).forEach((key, index) => {
                        if (key.startsWith("F") && parseInt(key.slice(1)) % 2 !== 0) {
                            const nextKey = `F${parseInt(key.slice(1)) + 1}`;
                            if (item[nextKey]) {
                                emailCredentials[item[key]] = item[nextKey];
                            }
                        }
                    });
                });


                emailCredentials.enableSSL = emailCredentials.enableSSL === "true"; // Convert enableSSL to boolean

                console.log("Mapped Email Credentials:", emailCredentials);

                // Call your state setter function to update the state
                setEmailCredential({
                    emailAddress: emailCredentials.emailAddress,
                    Password: emailCredentials.Password,
                    hostName: emailCredentials.HostName,
                    port: emailCredentials.Port,
                    enableSSL: emailCredentials.enableSSL,
                });
            }
        };
    }


    useEffect(() => {
        fetchMessageTemplateData(3);
    }, []);
    useEffect(() => {
        fetchMessageTemplateData(2);
    }, []);

    // const fetchMessageTemplateDataById = async () => {
    //     
    //     const response = await SettingApi.GetSettingById(msgTemplateId)
    //     if (response) {
    //         console.log("response", response);

    //         setLabelVal({
    //             URL: response.Result.F3 || "",
    //             QueryString: response.Result.F5 || "",
    //             mobileNoLength: response.Result.F7 || "",
    //             encodeSMS: response.Result.F9 === "true",
    //             countryCode: response.Result.F11 || "",
    //         });
    //         setRows((prevRows) => {
    //             const updatedRows = [...prevRows];
    //             updatedRows[0] = { left: "", right: response.Result.F3 || "" };
    //             updatedRows[1] = { left: "", right: response.Result.F5 || "" };
    //             updatedRows[2] = { left: "", right: response.Result.F7 || "" };
    //             updatedRows[3] = { left: "", right: response.Result.F9 === "true" ? "true" : "false" };
    //             updatedRows[4] = { left: "", right: response.Result.F11 || "" };
    //             return updatedRows;
    //         });
    //     }
    // };

    // useEffect(() => {
    //     fetchMessageTemplateDataById();
    // }, [msgTemplateId]);



    console.log("emailCredential", emailCredential);

    const handleEmailCreChange = (e) => {
        const { name, value } = e.target;

        // Update the emailCredential state
        setEmailCredential((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const handelEmailCreSave = async () => {
        const response = await SettingApi.CreateEmailSetting(emailCredential, EmailCrelabel)
        if (response) {
            console.log("response", response);
        }
    }

    const handleEmailCreUpdate = async () => {

        const data = [
            { key: EmailCrelabel.emailAddress, value: emailCredential.emailAddress },
            { key: EmailCrelabel.Password, value: emailCredential.Password },
            { key: EmailCrelabel.hostName, value: emailCredential.hostName },
            { key: EmailCrelabel.port, value: emailCredential.port },
            { key: EmailCrelabel.enableSSL, value: emailCredential.enableSSL }
        ];

        const response = await SettingApi.UpdateByType(2, data)
        if (response) {
            console.log("response", response);
            Swal.fire({ title: "Updated", text: "Updated Successfully", icon: "success", width: "320px" })
            fetchMessageTemplateData(2);
        }
    }



    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Setting</h2>
                </div>
                <div className="control_radius">
                    <div className="company_info-text-im depart_top">Email</div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="" required /> */}
                                    <label class="modify_p_text2">Enter Email:</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" value={emailField.Value} onChange={(e) => setEmailField({ ...emailField, Value: e.target.value })} required />
                                    <label class="modify_p_text2">Email value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        <button
                            id="SaveBtnMain"
                            className={`save-button-main-save hovered`}
                            onClick={handleSave}
                        >
                            Save
                        </button>

                        <button
                            id="SaveBtnMain"
                            className={`update-button-main-save hovered`}
                        >
                            Update
                        </button>
                    </div>
                    <div className="company_info-text-im depart_top">Message Template</div>
                    {/* <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Query/string</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Query/string Value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Mobile</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Mobile Value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="company_control">
                        {/* <select
                            className="modify_im_input mode_category1"
                            name="encodeSMS"
                            value={msgTemplateId}
                            onChange={(e) => setMsgTemplateId(e.target.value)}
                            required
                        >
                            <option value="">select</option>
                            {
                                templateData && templateData.map((data, index) => (
                                    < option key={data.id} value={data.id}>{`Message Template ${index + 1}`}</option >
                                ))
                            }
                        </select> */}

                        <div className="setting-input-box">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode-setting"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">URL</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {rows.map((row, index) => {

                        const labelKeys = Object.keys(label);
                        const currentLabelKey = labelKeys[index % labelKeys.length]; // Loop through labels
                        const currentLabel = label[currentLabelKey];
                        return (
                            <div key={index} className="company_control">
                                <div className="stock-im-dep1">
                                    <div className="input-box-Imo1 input-height2">
                                        <div className="input-box-mok1">
                                            {/* <input
                                                className="modify_im_input mode_category1"
                                                type="text"
                                                name="left"
                                                value={row.left}
                                                onChange={(e) => handleInputChange(index, 'left', e)}
                                                required
                                            /> */}
                                            <label className="modify_p_text2">{currentLabel}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="stock-im-dep1">
                                    <div className="input-box-Imo1 input-height2">
                                        <div className="input-box-mok1">
                                            {/* <input
                                                className="modify_im_input mode_category1"
                                                type="text"
                                                // name={currentLabelKey}
                                                name={currentLabelKey}
                                                value={row.right}
                                                onChange={(e) => handleInputChange(index, 'right', e)}
                                                // onChange={(e) => handleChange(index, 'right', e)}
                                                required
                                            /> */}


                                            {currentLabelKey === "encodeSMS" ? (
                                                // Render select dropdown for encodeSMS
                                                <select
                                                    className="modify_im_input mode_category1"
                                                    name="encodeSMS"
                                                    value={labelVal.encodeSMS}
                                                    onChange={(e) => handleInputChange(index, "", e)}
                                                    required
                                                >
                                                    <option value="true">True</option>
                                                    <option value="false">False</option>
                                                </select>
                                            ) : (
                                                // For other labels, render a text input
                                                <input
                                                    className="modify_im_input mode_category1"
                                                    type="text"
                                                    name={currentLabelKey} // Set name as current label key
                                                    value={row.right || ""} // Bind to 'right' field
                                                    onChange={(e) => handleInputChange(index, "right", e)} // Update 'right' field
                                                    required
                                                />
                                            )}


                                            <label className="modify_p_text2">{currentLabelKey}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className='flex-add-row'>
                        <button
                            id="AddRowBtn"
                            className="add-row-button"
                            onClick={addRow}
                        >
                            <Icon icon="gridicons:add" className='add-row-icon' />
                        </button>
                    </div>
                    <div className="ButtonTabSave">

                        {msgTemplateId ? (
                            <button
                                id="UpdateBtnMain"
                                className={`update-button-main-save hovered`}
                                onClick={handleMessageUpdate}
                            >
                                Update
                            </button>
                        ) : (
                            <button
                                id="SaveBtnMain"
                                className={`save-button-main-save hovered`}
                                onClick={handleMessageSave}
                            >
                                Save
                            </button>
                        )}




                    </div>
                    <div className="company_info-text-im depart_top">Email Credential</div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="" required /> */}
                                    <label class="modify_p_text2">Email Address</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        value={emailCredential.emailAddress}
                                        type="text" name="emailAddress" required onChange={handleEmailCreChange} />
                                    <label class="modify_p_text2">value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="" required /> */}
                                    <label class="modify_p_text2">App Password</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        value={emailCredential.Password}
                                        type="text" name="Password" onChange={handleEmailCreChange} required />
                                    <label class="modify_p_text2">Value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="" required /> */}
                                    <label class="modify_p_text2">Host Name</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="hostName" required onChange={handleEmailCreChange}
                                        value={emailCredential.hostName}
                                    />
                                    <label class="modify_p_text2">Value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    {/* <input className="modify_im_input mode_category1"
                                        type="text" name="" required /> */}
                                    <label class="modify_p_text2">Port</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        value={emailCredential.port}
                                        type="text" name="port" required onChange={handleEmailCreChange} />
                                    <label class="modify_p_text2">Value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">

                                    <label class="modify_p_text2">Enable SSL</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select className="modify_im_input mode_category1"
                                        value={emailCredential.enableSSL}
                                        type="text" name="enableSSL" required onChange={handleEmailCreChange} >
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                    <label class="modify_lbl_text3">value</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        {
                            emailCredential ? (<button
                                id="SaveBtnMain"
                                className={`update-button-main-save hovered`}
                                onClick={handleEmailCreUpdate}
                            >
                                Update
                            </button>) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handelEmailCreSave}
                                >
                                    Save
                                </button>
                            )
                        }



                    </div>

                </div>
            </div>
        </div >
    )
}

export default Setting;
